/**
 * resolveTickEntities — Build player / structures / damageable lists for one tick.
 * Prefers MatchEntityRegistry when present (P3-01 single source of truth).
 */
export function resolveTickEntities(context = {}) {
  const {
    entityRegistry = null,
    championEntity = null,
    garenEntity = null,
    dummyEntity = null,
    secondaryChampions = null,
    allTurretEntities = [],
    activeMinions = [],
    activeJungleCamps = []
  } = context;

  const player = (entityRegistry && entityRegistry.getPlayer()) || championEntity;

  let secondaries = secondaryChampions;
  if (!secondaries) {
    if (entityRegistry) {
      secondaries = entityRegistry.getChampions().filter((c) => c !== player);
    } else {
      secondaries = [garenEntity, dummyEntity].filter(Boolean);
    }
  }

  const structures = entityRegistry
    ? entityRegistry.getStructures().filter((t) => !t.isDead)
    : allTurretEntities.filter((t) => !t.isDead);

  const allMinionDomains = activeMinions.map((m) => m.domain);
  const activeJungleMonsters = activeJungleCamps.flatMap((c) => (
    c.state && c.state.isAlive && c.state.monsters
      ? c.state.monsters.filter((m) => !m.isDead)
      : []
  ));

  const allDamageable = [
    player,
    ...secondaries,
    ...structures,
    ...allMinionDomains,
    ...activeJungleMonsters
  ].filter((e) => e && !e.isDead);

  return {
    player,
    secondaries,
    structures,
    allMinionDomains,
    activeJungleMonsters,
    allDamageable
  };
}
